const googleAnalyticsScriptID = 'google-script';
const googleAnalyticsMeasurementID = 'G-P3GRY0B5MX';
const isProd = process.env.REACT_APP_ENV === 'prod';

export function trackGoogleAnalyticsEvent(eventName, properties = undefined) {
  if (!isProd) {
    // eslint-disable-next-line no-console
    console.log(
      `Google Analytics event: %c${eventName}`, // nosemgrep
      'background-color:lime; color:black;',
      properties ? 'with properties:' : '',
      properties || ''
    );
    return;
  }

  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, properties);
}

export default function googleScript() {
  if (!isProd || document.getElementById(googleAnalyticsScriptID)) return;

  const script = document.createElement('script');
  script.id = googleAnalyticsScriptID;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsMeasurementID}`;
  script.async = true;

  const scriptConfig = document.createElement('script');
  scriptConfig.innerText = 'window.dataLayer = window.dataLayer || [];' +
    'window.gtag = function gtag(){window.dataLayer.push(arguments);};' +
    'window.gtag(\'js\', new Date());' +
    `window.gtag('config', '${googleAnalyticsMeasurementID}');`;

  document.body.appendChild(script);
  document.body.appendChild(scriptConfig);
}

export const events = {
  CONTACT_FORM_VIEW: 'contact_form_view',
  CONTACT_RELEVANT_ARTICLES_SHOWN: 'contact_relevant_articles_shown',
  CONTACT_RELEVANT_ARTICLE_CLICK: 'contact_relevant_article_click',
  CONTACT_FORM_SUBMIT_ATTEMPT: 'contact_form_submit_attempt',
  CONTACT_FORM_SUBMIT_SUCCESS: 'contact_form_submit_success',
};
